import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LuCheck } from "react-icons/lu";
import { clearSaleConfirmation } from "../../reducers/userConfigSlice";

export const SaleConfirmation = () => {
  const dispatch = useDispatch();
  const confirmation = useSelector(state => state.aplicationConfig.userConfig.saleConfirmation);
  useEffect(() => {
    if (!confirmation) return undefined;
    const timer = setTimeout(() => dispatch(clearSaleConfirmation(confirmation.orderId)), 1300);
    return () => clearTimeout(timer);
  }, [confirmation, dispatch]);
  if (!confirmation) return null;
  return <div key={confirmation.orderId} className="tpvSaleConfirmation" role="status" aria-live="polite">
    <div className="tpvSaleConfirmationMessage"><LuCheck aria-hidden="true"/><strong>{confirmation.number} confirmado</strong><span>Nueva venta lista · Recogida en tienda</span></div>
  </div>;
};
